<template>
  <router-link class="chat-group" :class="{ 'active': isCurrentChatGroup()}" tag="li" :to="{ name: 'message', params: { chat_group_id: chatGroup.id }}">
    <img :src="displayAvatar" class="avatar">

    <time>{{ formatTime(chatGroup.updated_at) }}</time>
    <div class="title">{{ chatGroup.job.title }}</div>
    <div class="name">{{ displayName }}</div>
    <div class="unread-badge" v-if="chatGroup.unread_count > 0">{{ chatGroup.unread_count }} 則新訊息</div>

    <div class="latest-message" v-if="chatGroup.latest_message">
      {{ chatGroup.latest_message.content }}
    </div>
  </router-link>
</template>


<script>

export default {
  props: ['chatGroup', 'currentChatGroup', 'currentUserId'],
  data() {
    return {
    };
  },
  created() {},

  computed:
    {
      displayAvatar() {
        if (this.chatGroup.candidate.id === this.currentUserId) {
          return this.chatGroup.employer.display_avatar;
        } else {
          return this.chatGroup.candidate.display_avatar;
        }
      },

      displayName() {
        if (this.chatGroup.candidate.id === this.currentUserId) {
          return this.chatGroup.employer.display_name;
        } else {
          return this.chatGroup.candidate.display_name;
        }
      }
    },

  methods: {
    formatTime(time){
      return moment(time).locale('zh-TW').calendar();
    },
    isCurrentChatGroup() {
      return this.currentChatGroup && (this.currentChatGroup.id === this.chatGroup.id);
    }

  }
}
</script>


// WEBPACK FOOTER //
// app/javascript/packs/messenger/chat_group.vue